import type Button from "../../../src/models/Button";
import { useEffect, useRef, useState } from "react";
import { isUiModeExpert, uiModeWatcher } from "../../../src/uiMode";
import BaseDialog from "../../../src/modelDialogs/BaseDialog";
import { useOnChangeWatcher } from "../../../src/models/useOnChangeWatcher";
import { itx } from "../../../src/translationItx/itx";
import { getButton3DViewData, type Button3DViewContext } from "./button3DViewData";
import { ModelViewControl, type ModelViewActions } from "./ModelViewControl";
import "./modelView.scss";

/** Owned by DialogHost, independently of the editor that opened it. */
export function Button3DDialog({ button, page, press }: Button3DViewContext & { button: Button }) {
  const [photoQuality, setPhotoQuality] = useState(false);
  const viewActions = useRef<ModelViewActions>(null);
  useOnChangeWatcher(uiModeWatcher);
  const expert = isUiModeExpert();
  useEffect(() => { if (!expert) setPhotoQuality(false); }, [expert]);
  useOnChangeWatcher(button);
  useOnChangeWatcher(button.template);
  useOnChangeWatcher(button.template?.knxProductData);
  useOnChangeWatcher(button.channels);
  const { model, parameters } = getButton3DViewData(button, { page, press });
  return <BaseDialog dialogId="" className="C1_button3DDialog"
    title={itx("c1.button3d.title", "Taster · 3D-Vorschau")}
    moreHeaderButtons={expert && <label className="C1_photoQualityToggle" onPointerDown={event => event.stopPropagation()}>
      <input type="checkbox" checked={photoQuality} data-testid="photo-quality-at-rest"
        onChange={event => setPhotoQuality(event.target.checked)} />
      {itx("c1.button3d.photoQualityToggle", "Fotoqualität bei Stillstand")}
    </label>}
    moreButtons={<>
      <button type="button" className="button" onClick={() => viewActions.current?.front()}>{itx("c1.button3d.front", "Frontansicht")}</button>
      <button type="button" className="button" onClick={() => viewActions.current?.perspective()}>{itx("c1.button3d.perspective", "Perspektive")}</button>
    </>}
    noOkButton abortCaption={itx("c1.button3d.close", "Schließen")} noMinWidth bodyNoMinWidth
    style={{ width: "min(840px, calc(100vw - 32px))", maxWidth: "calc(100vw - 32px)" }}>
    {model && <ModelViewControl model={model} parameters={parameters} photoQualityAtRest={expert && photoQuality}
      showViewButtons={false} viewActionsRef={viewActions} />}
  </BaseDialog>;
}
